<template>
  <b-container class="bv-example-row">
    <b-row class="justify-content-md-center">
      <b-col cols="12" md="auto">
        <img alt="Vue logo" src="../assets/logo.png" style="width: 125px;">
        <h2>Bienvenido a Aircab</h2>
        <b-form @submit="onSubmit">
          <b-form-group
            id="input-group-1"
            label="Nombre de Usuario"
            label-for="input-1"
          >

            <b-form-input
              id="input-1"
              v-model="email"
              type="text"
              required
              placeholder="Nombre de Usuario"
            ></b-form-input>
          </b-form-group>


          <b-form-group
            id="input-group-1"
            label="Contraseña"
            label-for="password"
          >
            <b-form-input
              id="password"
              v-model="password"
              type="password"
              required
              placeholder="Contraseña"
            ></b-form-input>
          </b-form-group>

          <b-alert show variant="danger" v-show="error">{{errorMsg}}</b-alert>

          <b-button block type="submit" variant="primary">Iniciar</b-button>
          <!--<b-button type="submit" variant="danger" v-on:click="lanzador">Lanzador</b-button>-->
        </b-form>
        <p>Versión {{version}}</p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Parse from 'parse'
  import { version } from '../app'
  export default {
    data() {
      return {
        version: null,
        email: null,
        password: null,
        error: false,
        errorMsg: ''
      }
    },
    async created () {
      this.version = version
      var currentUser = Parse.User.current()
    },
    methods: {
      lanzador () {
        window.open('/','winname',"directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no,width=400,height=350");
      },
      async onSubmit (evt) {
        evt.preventDefault()
        let vue = this
        vue.error = false
        if(vue.email.length > 0 && vue.password.length > 0){
          vue.error = false
          try {
            let user = await Parse.User.logIn(vue.email, vue.password)
            console.log('usuario', user)
            vue.$router.replace('/')
            /*
            if (user.get('virtual')) {
              vue.$router.replace('home')
            } else {
              Parse.User.logOut().then(() => {
                vue.error = true
                vue.errorMsg = 'Usuario sin privilegios'
              })
            }
            */
          } catch (error) {
            vue.error = true
            vue.errorMsg = 'Usuario / Contraseña Incorrecta'
            console.log('error', error)
          }

        }
                
      }
    }
  }
</script>